import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "com_title1" }, [
  /*#__PURE__*/_createElementVNode("span", null, "最近チェックしたページ")
], -1)
const _hoisted_2 = { class: "com_topic_list1" }
const _hoisted_3 = { class: "meta1" }
const _hoisted_4 = { class: "com_tag2" }
const _hoisted_5 = { class: "body1" }
const _hoisted_6 = { class: "small1" }
const _hoisted_7 = { class: "roboto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentlyViewedListData, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.contentId
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(item.categoryName), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: `/${item.detailPath}/categoryId/${item.categoryId}/contentsId/${item.contentId}`,
              class: "com_link1"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.title), 1)
              ]),
              _: 2
            }, 1032, ["to"]),
            _createElementVNode("span", _hoisted_6, [
              _createTextVNode("［ 閲覧日 "),
              _createElementVNode("span", _hoisted_7, _toDisplayString(item.viewDate), 1),
              _createTextVNode(" ］")
            ])
          ])
        ]))
      }), 128))
    ])
  ], 64))
}